module.exports = __webpack_public_path__ + "img/dianbiao.85105ff3.png";